import { useContext } from 'react';

import TableBodyCell from 'components/common/Table/TableBodyCell/TableBodyCell';
import TableRow from 'components/common/Table/TableRow/TableRow';
import { UserPaginationItemDto } from 'components/users/users.dto';
import { EditIcon, InfoWarning, DeleteIcon } from 'components/common/Icons/Icons';
import Tooltip from 'components/common/Tooltip/Tooltip';
import { convertPhoneNumberForDisplay } from 'common/utils/string.utils';
import { AccountStatus, MainContactCellValue } from 'components/users/users.enums';
import { NOT_CONFIRMED_EMAIL_WARNING_MESSAGE } from 'components/users/users.constants';
import { hasPermission } from 'components/permissions/permissions.utils';
import { PermissionName } from 'components/permissions/permissions.enum';
import { RootStoreContext } from 'index';

import styles from './UsersTableRow.module.scss';

interface UsersTableRowProps {
  user: UserPaginationItemDto;
  onClick: () => void;
  onEditClick: (event: any) => void;
  onDeleteClick: (event: any) => void;
}

const UsersTableRow = ({ user, onClick, onEditClick, onDeleteClick }: UsersTableRowProps) => {
  const { authStore } = useContext(RootStoreContext);
  const userPermissions = authStore.account?.permissions ?? [];
  const canUserUpdate = hasPermission(userPermissions, [PermissionName.UserUpdate]);

  return (
    <TableRow className={styles.tableColumnsWithButtons}>
      <div className={styles.tableRowTemplate} onClick={onClick}>
        <TableBodyCell>{user.fullName}</TableBodyCell>
        <TableBodyCell>
          <>
            {user.email}
            {(!user.accountStatus || user.accountStatus === AccountStatus.Pending) && (
              <Tooltip title={NOT_CONFIRMED_EMAIL_WARNING_MESSAGE}>
                <span className={styles.warningIconWrap}>
                  <InfoWarning />
                </span>
              </Tooltip>
            )}
          </>
        </TableBodyCell>
        <TableBodyCell>{convertPhoneNumberForDisplay(user.phone)}</TableBodyCell>
        <TableBodyCell>{user.roles.join(', ')}</TableBodyCell>
        <TableBodyCell>{user.isMainContact ? MainContactCellValue.True : MainContactCellValue.False}</TableBodyCell>
        <TableBodyCell>
          {canUserUpdate && (
            <div className={styles.actionButtons}>
              <EditIcon onClick={onEditClick} />
              {authStore.account?.id !== user.id && (
                <DeleteIcon className={styles.deleteIcon} onClick={onDeleteClick} />
              )}
            </div>
          )}
        </TableBodyCell>
      </div>
    </TableRow>
  );
};

export default UsersTableRow;
